import type { UserType } from '@econtractor/types';
import SolarIcon from 'components/icons/SolarIcon';

interface UserAdminItemsProps {
    user: UserType;
}

const UserAdminItems = ({ user }: UserAdminItemsProps) => {
    return (
        <div className="d-flex align-items-center gap-1">
            {user.admin ? (
                <SolarIcon name="check-circle-fill" className="fs-16 text-success" />
            ) : (
                <SolarIcon name="x-circle-fill" className="fs-16 text-danger" />
            )}
            {!!user.userMaster && <SolarIcon name="star-fill" className="fs-16 text-primary" />}
        </div>
    );
};

export default UserAdminItems;
